import { render, staticRenderFns } from "./Schools.vue?vue&type=template&id=45d58922&scoped=true"
import script from "./Schools.vue?vue&type=script&lang=js"
export * from "./Schools.vue?vue&type=script&lang=js"
import style0 from "./Schools.vue?vue&type=style&index=0&id=45d58922&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d58922",
  null
  
)

export default component.exports